// src/pages/AnnouncementDetail.tsx
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

interface Announcement {
  id: number;
  title: string;
  content: string;
  image: string | null;
  created_at: string;
  views: number;
  author_name?: string;
  summary?: string;
}

const AnnouncementDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [announcement, setAnnouncement] = useState<Announcement | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    fetch(`https://fellfell.ir/api/announcements.php?action=single&id=${id}`, {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(data => {
        if (data.success && data.data) {
          setAnnouncement(data.data);
        } else {
          setError('اطلاعیه یافت نشد');
        }
        setLoading(false);
      })
      .catch(() => {
        setError('خطا در بارگذاری');
        setLoading(false);
      });
  }, [id]);

  // ── اشتراک‌گذاری ──────────────────────────────────────
  const share = (platform: string) => {
    const url = window.location.href;
    const text = announcement?.title || '';
    let shareUrl = '';
    if (platform === 'telegram') {
      shareUrl = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
    } else if (platform === 'whatsapp') {
      shareUrl = `https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`;
    } else if (platform === 'twitter') {
      shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
    } else if (platform === 'facebook') {
      shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    }
    if (shareUrl) window.open(shareUrl, '_blank');
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '50px' }}>⏳ در حال بارگذاری...</div>;
  if (error || !announcement) return <div style={{ padding: '20px', color: '#c62828' }}>{error || 'اطلاعیه یافت نشد'}</div>;

  return (
    <div style={{ direction: 'rtl', maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
      <Link to="/announcements" style={{ color: '#2e7d32', textDecoration: 'none', display: 'inline-block', marginBottom: '20px' }}>
        ← بازگشت به لیست اطلاعیه‌ها
      </Link>

      <div style={{ background: '#fff', borderRadius: '16px', padding: '30px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
        {announcement.image && (
          <img
            src={`/uploads/announcements/${announcement.image}`}
            alt={announcement.title}
            style={{ width: '100%', maxHeight: '400px', objectFit: 'cover', borderRadius: '12px', marginBottom: '20px' }}
            onError={(e) => (e.currentTarget.style.display = 'none')}
          />
        )}

        <h1 style={{ color: '#1e3a1e', fontSize: '28px' }}>{announcement.title}</h1>
        <div style={{ display: 'flex', gap: '15px', color: '#888', fontSize: '14px', marginBottom: '20px', flexWrap: 'wrap' }}>
          <span>📅 {new Date(announcement.created_at).toLocaleDateString('fa-IR')}</span>
          <span>👁 {announcement.views} بازدید</span>
          {announcement.author_name && <span>✍️ {announcement.author_name}</span>}
        </div>

        {announcement.summary && (
          <div style={{ background: '#f5faf5', padding: '15px', borderRadius: '10px', marginBottom: '20px', borderRight: '4px solid #2e7d32' }}>
            <strong>📌 خلاصه:</strong> {announcement.summary}
          </div>
        )}

        <div style={{ lineHeight: '2', fontSize: '16px' }}>
          {announcement.content}
        </div>

        {/* ── دکمه‌های اشتراک‌گذاری ──────────────────── */}
        <div style={{ marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #eee' }}>
          <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>🔗 اشتراک‌گذاری:</p>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <button onClick={() => share('telegram')} style={{ background: '#0088cc', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' }}>تلگرام</button>
            <button onClick={() => share('whatsapp')} style={{ background: '#25D366', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' }}>واتساپ</button>
            <button onClick={() => share('twitter')} style={{ background: '#1DA1F2', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' }}>توییتر</button>
            <button onClick={() => share('facebook')} style={{ background: '#1877F2', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' }}>فیس‌بوک</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementDetail;